import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client/core'

export function createGlobalGraphClient(endpoint: string, getAccessToken: () => string | undefined) {
  const authLink = new ApolloLink((operation, forward) => {
    const token = getAccessToken()
    if (!token) throw new Error('Sign in before accessing the global graph.')
    operation.setContext(({ headers }) => ({ headers: { ...headers, authorization: `Bearer ${token}` } }))
    return forward(operation)
  })
  return new ApolloClient({
    link: authLink.concat(new HttpLink({ uri: endpoint })),
    cache: new InMemoryCache(),
    defaultOptions: { watchQuery: { fetchPolicy: 'cache-and-network' }, query: { fetchPolicy: 'network-only' } }
  })
}
